// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://rmhjwmsfyinckjdjstqs.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJtaGp3bXNmeWluY2tqZGpzdHFzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTAwOTQxMzYsImV4cCI6MjA2NTY3MDEzNn0.Stpq3_pZZivVN1D08RB7Dmv9MGYXgCseg5ps_30KMsQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);